import { render, staticRenderFns } from "./visit-module.vue?vue&type=template&id=5cf59c20&scoped=true&"
import script from "./visit-module.vue?vue&type=script&lang=js&"
export * from "./visit-module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf59c20",
  null
  
)

export default component.exports